import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../../../../lib/utils';

function getProgressColor(value, disabled) {
  if (disabled) return 'bg-muted-foreground/50';
  if (value < 30) return 'bg-red-500';
  if (value < 70) return 'bg-yellow-500';
  return 'bg-green-500';
}

function getTextColor(value, disabled) {
  if (disabled) return 'text-muted-foreground';
  if (value < 30) return 'text-red-700';
  if (value < 70) return 'text-yellow-700';
  return 'text-green-700';
}

function ReviewProgress({ value, disabled }) {
  const progressColor = getProgressColor(value, disabled);
  const textColor = getTextColor(value, disabled);

  return (
    <div className="w-full max-w-[120px] mx-auto">
      <div className="relative h-5 w-full rounded border border-border bg-background overflow-hidden">
        <div
          className={cn('absolute left-0 top-0 h-full transition-all duration-300', progressColor)}
          style={{ width: `${value}%` }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className={cn('text-xs font-medium', textColor)}>{value}%</span>
        </div>
      </div>
    </div>
  );
}

ReviewProgress.propTypes = {
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
};

ReviewProgress.defaultProps = {
  disabled: false,
};

export default ReviewProgress;
